import { Crown } from 'lucide-react';
import { Link } from 'react-router-dom';

type ChapterErrorType = 'vip' | 'general';

interface ChapterErrorProps {
    type: ChapterErrorType;
    onBack: () => void;
}

export default function ChapterError({ type, onBack }: ChapterErrorProps) {
    if (type === 'vip') {
        return (
            <div className="min-h-screen bg-[#111] lg:bg-black text-white flex flex-col items-center justify-center px-4">
                <Crown className="w-12 h-12 text-amber-400 mb-8" />
                <h1 className="text-xl font-bold mb-3">Conteúdo exclusivo para VIP</h1>
                <div className="flex gap-3">
                    <Link to="/landing" className="px-6 py-3 bg-orange-500 rounded-xl font-semibold">
                        Ver planos VIP
                    </Link>
                    <button type="button" onClick={onBack} className="px-6 py-3 bg-white/10 rounded-xl font-medium">
                        Voltar
                    </button>
                </div>
            </div>
        );
    }

    return (
        <div className="min-h-screen bg-[#111] lg:bg-black text-white flex flex-col items-center justify-center px-4 text-center">
            <h1 className="text-xl font-bold mb-3 text-red-400">Ocorreu um erro ao carregar o capítulo</h1>
            <p className="text-white/60 mb-8 max-w-md">
                O conteúdo pode estar temporariamente indisponível ou você não tem permissão para acessá-lo.
            </p>
            <button
                type="button"
                onClick={onBack}
                className="px-6 py-3 bg-white/10 rounded-xl font-medium hover:bg-white/20 transition-colors"
            >
                Voltar
            </button>
        </div>
    );
}
